import type { SVGProps } from 'react';
import { arc as d3Arc } from 'd3-shape';

interface Props extends SVGProps<SVGPathElement> {
  innerRadius?: number;
  outerRadius?: number;
  cornerRadius?: number;
  startAngle?: number;
  endAngle?: number;
  padAngle?: number;
  padRadius?: number;
}

const Arc = ({
  innerRadius,
  outerRadius,
  cornerRadius,
  startAngle,
  endAngle,
  padAngle,
  padRadius,
  ...restProps
}: Props) => {
  const arc = d3Arc<null>();
  if (innerRadius !== undefined) arc.innerRadius(innerRadius);
  if (outerRadius !== undefined) arc.outerRadius(outerRadius);
  if (cornerRadius !== undefined) arc.cornerRadius(cornerRadius);
  if (startAngle !== undefined) arc.startAngle(startAngle);
  if (endAngle !== undefined) arc.endAngle(endAngle);
  if (padAngle !== undefined) arc.padAngle(padAngle);
  if (padRadius !== undefined) arc.padRadius(padRadius);
  return <path d={arc(null) || ''} {...restProps} />;
};

export default Arc;
